/**
 * Trailing line the routine-pane wire preamble ends with so the project-chat
 * transcript can recover the clinician's words without matching prompt copy.
 *
 * Callers concatenate ``${context}\n\n${userText}``, so the wire text is
 * ``…\n\nUser request:\n\n<user text>``. A context-only seed ends at the
 * marker (nothing after it) and still renders as a title-only bubble.
 */
export const WORKFLOW_CONTEXT_USER_REQUEST_MARKER = 'User request:';
